import React from "react";
import CareerApplicationForm from "./CareerApplicationForm";
interface ApplyFormProps { jobTitle: string; applicationUrl: string; }
const ApplyForm: React.FC<ApplyFormProps> = ({ jobTitle, applicationUrl }) => (
  <CareerApplicationForm jobTitle={jobTitle} applicationUrl={applicationUrl} />
);
export default ApplyForm;
